import cookie from '@s-ui/js/lib/cookie'
const PURPOSES = [
  'cookies',
  'select_basic_ads',
  'create_ads_profile',
  'select_personalized_ads',
  'create_content_profile',
  'select_personalized_content',
  'measure_ad_performance',
  'measure_content_performance',
  'market_research',
  'improve_products'
]
const SPECIAL_FEATURES = [
  'geolocation_data'
  // 'device_characteristics',
]
const BOROS_BASE64_COOKIE_NAME = 'borosTcf'

const {set: setCookie} = cookie

export function saveBorosTcfCookie() {
  if (window.Didomi.isUserConsentStatusPartial()) return

  const userConsents = window.Didomi.getUserConsentStatusForAll()
  const consents = {}
  const specialFeatures = {}
  PURPOSES.forEach((id, iabNumber) => {
    if (userConsents.purposes.enabled.includes(id)) {
      consents[iabNumber + 1] = true
    }
  })
  SPECIAL_FEATURES.forEach((id, iabNumber) => {
    if (userConsents.purposes.enabled.includes(id)) {
      specialFeatures[iabNumber + 1] = true
    }
  })
  const borosObject = {
    policyVersion: 2,
    cmpVersion: 1,
    purpose: {
      consents
    },
    specialFeatures
  }
  setCookie(BOROS_BASE64_COOKIE_NAME, btoa(JSON.stringify(borosObject)))
}
